import React, { useRef, useEffect, useState, useMemo } from 'react'
import { useRouter } from 'next/router'
import Slider from 'react-slick'

import withRootContext from 'context/withRootContextHOC'
import { useServiceScheduleContext, actionTypes } from '../../../context/serviceScheduleContext'
import { usePetAndServicesContext } from '../../../context/petAndServicesContext'
import { getPurchasedPackages } from 'src/services/purchasedPackagesService'

import PageContainer from 'src/components/pageContainer'
import { Radio } from 'src/components/forms'

import FormSteps from 'src/components/formSteps'
import SchedulingInfo from 'src/components/schedulingSteps/schedulingInfo'
import LastSchedulingsCarousel from 'src/components/lastSchedulingsCarousel'
import PurchasedPackages from 'src/components/purchasedPackages'

import { getPetPhotoByType, getServiceIconByName, splitServiceName, focus } from 'src/utils'
import { PAGE_URL, isMobile, scrollTop } from 'utils'
import { featureFlags } from 'src/utils/constants'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import * as S from './styles'
import * as Gs from 'src/styles/global'

import MODAL from '../../../utils/modals'
import { assetPrefix } from '../../../config/env_config'
import WarningModal from '../../warningModal'

const PetAndServices = (props) => {
  const { context } = props

  // Adaptação as antigas funções
  const router = useRouter()
  const { state: schedulingState, dispatch, functions: schedulingFunctions } = useServiceScheduleContext()
  const { modal } = schedulingState
  const { functions } = usePetAndServicesContext()
  const {
    handleWarningModalClose
  } = schedulingFunctions

  const {
    serviceData,
    additionalServiceData,
    petsData,
    formList,
    scheduleBody,
    obs,
    selectedPurchasedPackage
  } = schedulingState

  const {
    handleSelectedMyPet,
    handleUnselectPet,
    handleSelectedService,
    handleToggleAdditional,
    handleAdditionalQuantity,
    retrievePetsData,
    retrieveServiceData,
    handlePurchasedPackageSelect
  } = functions

  const [petsDataLoaded, setPetsDataLoaded] = useState(false)
  const [keyboardOpen, setKeyboardOpen] = useState(false)
  const [isBanhoHidratacaoSelected, setIsBanhoHidratacaoSelected] = useState(false)
  const [bathPackage, setbathPackage] = useState()
  const [purchasedPackages, setPurchasedPackages] = useState([])

  // busca os pets
  const handleRetrieveData = async () => {
    await retrievePetsData({ context })
    setPetsDataLoaded(true)
  }

  // busca os pacotes adquiridos
  const fetchPurchasedPackages = async () => {
    if (router.query.category !== 'BANHO_TOSA') return
    try {
      context.showLoader()
      const response = await getPurchasedPackages({ status: ['ACTIVE', 'UNDER_REVIEW'] })

      if (response.success) {
        setPurchasedPackages(response.data.purchasedPackages || [])
      } else {
        console.error('Erro ao carregar pacotes adquiridos', response)
      }
    } catch (err) {
      console.error('Erro ao carregar pacotes adquiridos', err)
    } finally {
      context.hideLoader()
    }
  }

  useEffect(() => {
    handleRetrieveData()
  }, [])

  useEffect(() => {
    if (context.firstName) {
      handleRetrieveData()
      setPetsDataLoaded(false)
      fetchPurchasedPackages()
    }
  }, [context.firstName])

  // busca os serviços
  useEffect(() => {
    const retrieveData = async () => {
      if (!schedulingState?.serviceData?.length && router.query.category) {
        window.localStorage.setItem('category', router.query.category)
        await retrieveServiceData({ context, router })
      }
    }

    retrieveData()
  }, [router])

  useEffect(() => {
    const selected = serviceData.find(service => service.value === scheduleBody.service_id)
    setIsBanhoHidratacaoSelected(selected?.name === 'Banho&Hidratação')
    if (selected?.package) {
      setbathPackage(selected)
    } else {
      setbathPackage(null)
    }
  }, [scheduleBody.service_id, serviceData])

  const LOGGED_IN = context.firstName

  const queryCategory = router?.query?.category

  const selectedPet = petsData?.find(pet => pet.id === scheduleBody.pet_id)

  const inputRef = useRef(null)

  const mobile = isMobile()

  const additionalServicesRef = useRef(null)

  const onUpdateScheduling = (value) => { dispatch({ type: actionTypes.UPDATE_STATE, payload: value }) }

  const redirectToPetProfile = (query) => {
    router.push({
      pathname: PAGE_URL.PET_PROFILE,
      query
    })
  }

  const handleInputFocus = () => {
    if (isMobile() && !selectedPurchasedPackage) { setKeyboardOpen(true) }
    focus(inputRef, 'smooth', true)
  }

  const handleInputBlur = () => {
    if (isMobile()) { setKeyboardOpen(false) }
  }

  const handleNewPet = () => {
    const query = {
      redirectTo: `${PAGE_URL.SCHEDULING_PET_AND_SERVICES}?category=${queryCategory}`
    }

    if (scheduleBody.partner_id) {
      return dispatch({
        type: actionTypes.UPDATE_STATE,
        payload: {
          modal: MODAL.NEW_PET_WARNING(() => {
            handleWarningModalClose()
            redirectToPetProfile(query)
          })
        }
      })
    }

    redirectToPetProfile(query)
  }

  const handleObsChange = (input) => {
    if (input.target.value.length <= 255) {
      onUpdateScheduling({
        obs: input.target.value
      })
    }
  }

  const handleSelectOrUnselectPet = (pet) => {
    if (selectedPet?.id !== pet.id) {
      handleSelectedMyPet(pet, { context })
      scrollTop()
    } else {
      handleUnselectPet()
    }
  }

  const showSchedulingInfo = () => {
    return scheduleBody.pet_id !== undefined && !keyboardOpen
  }

  const openAuthModal = () => context.toggleModalSheet(MODAL.LOGIN_MODAL({ onCancel: context.toggleModalSheet, callback: context.toggleModalSheet }))

  const slickOptions = {
    arrows: !mobile && petsData.length > 4,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    pauseOnFocus: true,
    pauseOnHover: true,
    pauseOnDotsHover: true,
    autoplay: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ],
    nextArrow: <S.SliderArrow><S.SliderNextArrow /></S.SliderArrow>,
    prevArrow: <S.SliderArrow><S.SliderPrevArrow /></S.SliderArrow>
  }

  function getPetsCard () {
    if (petsData && petsData.length > 0) {
      return petsData.map((pet) => {
        // Se o cliente está agendando para mais de 1 pet, verifica se já foi marcado um serviço para o pet e desabilita a seleção do mesmo
        const showPet = !formList.length || formList.every(form => form.body.pet_id !== pet.id)
        const selected = selectedPet?.id === pet.id
        return (
          <div key={pet.id} className='slide-inner'>
            <S.Pet
              selected={selected}
              active={showPet}
              onClick={() => handleSelectOrUnselectPet(pet)}
            >
              <S.WrapperPetPhoto>
                <S.Photo
                  src={pet.photo || getPetPhotoByType(pet?.breed?.type)}
                  setDefaultPhoto={!pet.photo}
                  size='64px'
                  mobileSize='64px'
                />
                <S.TextInfo>
                  <span>{pet.name}</span>
                  <span>{pet?.breed?.name}</span>
                </S.TextInfo>
              </S.WrapperPetPhoto>
            </S.Pet>
          </div>
        )
      })
    }
    return null
  }

  const isDoctorIcon = (serviceName) => {
    return typeof serviceName === 'string' && (serviceName.includes('Clinica') || serviceName.includes('Clínica'))
  }

  const renderDiscountTag = ({ discountValue, additional = false, hideOnMobile = false, hideOnDesktop = false }) => {
    return (
      <S.DiscountTag additional={additional} hideOnMobile={hideOnMobile} hideOnDesktop={hideOnDesktop}>
        <S.Photo size='16px' mobileSize='16px' src={`${assetPrefix}/static/icons/bath-package-discount.svg`} borderRadiusNone /> {discountValue}% OFF
      </S.DiscountTag>
    )
  }

  const additionalServices = useMemo(() => {
    return selectedPurchasedPackage?.availableAdditionals || additionalServiceData
  }, [selectedPurchasedPackage?.availableAdditionals, additionalServiceData])

  const isPackagePurchaseEnabled = featureFlags.enablePackagePurchase

  const renderServiceCards = (services) =>
    services.map((service, index) => {
      const isServiceSelected = service.value === scheduleBody.service_id
      const isServicePackage = service?.package
      return (
        <S.ServiceCard
          key={service?.value || index}
          active
          onClick={() => handleSelectedService(service.value, additionalServiceData?.length > 0 ? additionalServicesRef : inputRef, { router, context, serviceName: splitServiceName(service.name) })}
          selected={isServiceSelected}
          isServicePackage={isServicePackage}
        >
          {isServicePackage ? (
            <>
              <S.Container isServicePackage={isServicePackage}>
                <S.Photo size='64px' mobileSize={`${isServicePackage ? '64px' : '40px'}`} noBorder src={getServiceIconByName(service.name)} />
                <S.TextInfo isService isServicePackage={isServicePackage}>
                  <span>{splitServiceName(service.name)}</span>
                </S.TextInfo>
                {isServicePackage && renderDiscountTag({ discountValue: service?.packageDiscount })}
              </S.Container>

              <S.ServiceOption>
                <Radio name='service' checked={isServiceSelected} />
              </S.ServiceOption>
            </>
          ) : (
            <>
              <S.ServiceRadioContainer hasBorder={!!service?.description}>
                <S.ServiceTitle>
                  <S.Photo size='24px' mobileSize='24px' isDoctorIcon={isDoctorIcon(service?.name)} borderRadiusNone noBorder src={getServiceIconByName(service.name, 'blue')} />
                  <S.TextInfo isService>
                    <span>{splitServiceName(service.name)}</span>
                  </S.TextInfo>
                </S.ServiceTitle>
                <S.ServiceOption>
                  <Radio name='service' checked={isServiceSelected} />
                </S.ServiceOption>
              </S.ServiceRadioContainer>
              {!!service?.description && (
                <S.ServiceDescription>
                  <span>{service?.description || ''}</span>
                </S.ServiceDescription>
              )}
            </>
          )}
        </S.ServiceCard>
      )
    })

  const { packageServices, regularServices } = serviceData.reduce(
    (groupServices, service) => {
      if (service.package) groupServices.packageServices.push(service)
      else groupServices.regularServices.push(service)
      return groupServices
    },
    { packageServices: [], regularServices: [] }
  )

  const visiblePackageServices = isPackagePurchaseEnabled ? packageServices : []

  const handleUpdateQuantity = (id, number) => {
    handleAdditionalQuantity(id, number)
  }

  const showPurchasedPackages =
    (!formList.length && purchasedPackages.length > 0 && !selectedPet)

  return (
    <PageContainer isSchedulingSteps>
      <FormSteps context={context}>
        <S.PageContainer>

          {(!formList.length && petsData?.length > 0) && <LastSchedulingsCarousel category={queryCategory} petsData={petsData} />}

          <Gs.WrapperFormAndCard hasFormList={!!formList.length}>
            <S.WrapperForm>
              {showPurchasedPackages && (
                <S.PurchasedPackagesWrapper>
                  <PurchasedPackages
                    purchasedPackages={purchasedPackages}
                    onPurchasedPackageSelect={handlePurchasedPackageSelect}
                  />
                </S.PurchasedPackagesWrapper>
              )}
              {/* Seleção de pets */}
              {(!selectedPet) &&
                <S.AlignWrappers paddingBottom={!(selectedPet && serviceData)}>
                  <S.WrapperTitle isPet>
                    <span>{purchasedPackages.length > 0 ? 'Selecione o pet para serviços avulsos' : 'Selecione o pet'}</span>
                  </S.WrapperTitle>

                  {petsData.length > 3 ? (
                    <S.SliderContainer>
                      <Slider {...slickOptions}>
                        {getPetsCard()}
                      </Slider>
                    </S.SliderContainer>
                  ) : (
                    <S.WrapperElements>
                      {getPetsCard()}
                    </S.WrapperElements>
                  )}

                  {(petsData.length <= 0) &&
                    <S.NoPetData>
                      {(petsDataLoaded && !LOGGED_IN) &&
                        <S.UseExistingPet onClick={() => openAuthModal()}>
                          <S.Photo src={`${assetPrefix}/static/icons/dog-foot-print.svg`} />
                          Usar pet cadastrado
                        </S.UseExistingPet>}

                      {(petsDataLoaded && LOGGED_IN) &&
                        <S.PetNotFound>
                          <S.Photo mobileSize='64px' src={`${assetPrefix}/static/icons/search-icon-blue.svg`} />
                          <S.PetNotFoundTitle>Nenhum pet cadastrado</S.PetNotFoundTitle>
                          <S.PetNotFoundTextInfo>
                            Não encontramos nenhum pet cadastrado. Clique no botão abaixo e cadastre seu pet.
                          </S.PetNotFoundTextInfo>
                        </S.PetNotFound>}

                      {(!petsDataLoaded) &&
                        <S.PetNotFound>
                          <S.Photo mobileSize='64px' src={`${assetPrefix}/static/icons/search-icon-blue.svg`} />
                          <S.PetNotFoundTitle>Estamos buscando seu pet</S.PetNotFoundTitle>
                        </S.PetNotFound>}
                    </S.NoPetData>}

                  <S.PetRegistration onClick={() => handleNewPet()}>
                    Cadastrar novo pet
                  </S.PetRegistration>
                </S.AlignWrappers>}

              {/* Seleção de serviços */}
              {(selectedPet && serviceData) &&
                <S.AlignWrappers paddingBottom>
                  {!selectedPurchasedPackage && (
                    <S.WrapperTitle isService>
                      <span>Selecione o serviço</span>
                    </S.WrapperTitle>
                  )}

                  <S.WrapperElements noMarginTop={selectedPurchasedPackage}>
                    {!selectedPurchasedPackage && (
                      <>
                        {visiblePackageServices.length > 0 && !formList.length && (
                          <S.WrapperServices packageServices>
                            {renderServiceCards(visiblePackageServices)}
                          </S.WrapperServices>
                        )}
                        <S.WrapperServices>
                          {renderServiceCards(regularServices)}
                        </S.WrapperServices>
                      </>
                    )}

                    <S.WrapperAdditionalServicesAndObs>
                      {/* Seleção de serviços adicionais */}
                      {(additionalServices?.length > 0 && selectedPet) &&
                        <S.WrapperAdditionalServices ref={additionalServicesRef}>
                          <S.WrapperTitle isServices isFlex isAdditionalServices>
                            <span>{selectedPurchasedPackage ? 'Deseja incluir um desses serviços?' : 'Serviços adicionais (opcional)'}</span>
                            {bathPackage && renderDiscountTag({ discountValue: bathPackage.packageDiscount, additional: true })}
                          </S.WrapperTitle>

                          <S.WrapperAdditionalServices>
                            <S.WrapperServices>
                              {
                                additionalServices.map((service, index) => {
                                  const isHidratacao = service.name === 'Hidratação'
                                  const isChecked = scheduleBody.additional_services.find(additional => additional?.id === service.value)

                                  if (isBanhoHidratacaoSelected && isHidratacao) {
                                    if (isChecked) handleToggleAdditional(service.value, { router, context })
                                    return null
                                  }
                                  const additionalQuantity = scheduleBody.additional_services?.find(additional => additional?.id === service.value)?.quantity || 0

                                  return (
                                    bathPackage ? (
                                      <S.AdditionalServices
                                        key={index} active selected={isChecked}
                                        isChecked={isChecked}
                                        onClick={() => handleToggleAdditional(service.value)}
                                      >
                                        <S.Photo
                                          size='32px' mobileSize='32px' src={getServiceIconByName(service.name)}
                                          borderRadiusNone
                                        />
                                        <label>{service.name}</label>
                                        <S.RightControls>
                                          <S.QuantityControls disabled={!isChecked}>
                                            <button
                                              aria-label='Diminuir quantidade'
                                              disabled={additionalQuantity === 0}
                                              onClick={e => {
                                                e.stopPropagation()
                                                handleUpdateQuantity(service.value, -1)
                                              }}
                                            >
                                              <img
                                                src={`${assetPrefix}/static/icons/minus.svg`}
                                                alt='Diminuir'
                                              />
                                            </button>

                                            <span>{additionalQuantity || 0}</span>

                                            <button
                                              aria-label='Aumentar quantidade'
                                              disabled={additionalQuantity === bathPackage.packageQuantity}
                                              onClick={e => {
                                                e.stopPropagation()
                                                handleUpdateQuantity(service.value, 1)
                                              }}
                                            >
                                              <img
                                                src={`${assetPrefix}/static/icons/plus-outline.svg`}
                                                alt='Aumentar'
                                              />
                                            </button>
                                          </S.QuantityControls>
                                        </S.RightControls>
                                      </S.AdditionalServices>
                                    ) : (
                                      <S.ServiceCard
                                        key={service?.id}
                                        active
                                        onClick={() => handleToggleAdditional(service.value, { router, context })}
                                        selected={isChecked}
                                      >
                                        <S.ServiceRadioContainer>
                                          <S.ServiceTitle>
                                            <S.Photo
                                              size='24px'
                                              mobileSize='24px'
                                              borderRadiusNone
                                              noBorder
                                              src={getServiceIconByName(service.name, 'blue')}
                                            />
                                            <S.TextInfo isService>
                                              <span>{service.name}</span>
                                            </S.TextInfo>
                                          </S.ServiceTitle>
                                        </S.ServiceRadioContainer>
                                      </S.ServiceCard>
                                    )
                                  )
                                })
                              }
                            </S.WrapperServices>
                          </S.WrapperAdditionalServices>

                        </S.WrapperAdditionalServices>}

                      {/* Observação */}
                      {selectedPet && !scheduleBody.isServicePackage &&
                        <S.TextareaContainer ref={inputRef}>
                          <label>
                            Observações
                          </label>
                          <S.ObsTextArea
                            placeholder='Escreva aqui alguma informação importante sobre o serviço ou seu pet.'
                            onChange={handleObsChange}
                            value={obs}
                            maxLength={255}
                            data-test='textarea-obs'
                            onFocus={handleInputFocus}
                            onBlur={handleInputBlur}
                          />
                          <S.Counter>
                            {obs.length}/255
                          </S.Counter>
                        </S.TextareaContainer>}
                    </S.WrapperAdditionalServicesAndObs>
                  </S.WrapperElements>
                </S.AlignWrappers>}
            </S.WrapperForm>

            {showSchedulingInfo() && !showPurchasedPackages && (
              <SchedulingInfo />
            )}

          </Gs.WrapperFormAndCard>
        </S.PageContainer>
      </FormSteps>

      <WarningModal
        visible={!!modal}
        cancelLabel={modal?.cancelLabel}
        confirmLabel={modal?.confirmLabel}
        type={modal?.type}
        title={modal?.title}
        subtitle={modal?.subtitle}
        onConfirm={modal?.onConfirm}
        onCancel={handleWarningModalClose}
        fullButton={modal?.fullButton}
        outlineCancelButton={modal?.outlineCancelButton}
        showClose={modal?.showClose}
        icon={modal?.icon ? modal?.icon : !modal?.professional ? `${assetPrefix}/static/icons/warning.svg` : ''}
        iconSize={modal?.iconSize}
        overflow={modal?.overflow}
        dataTest='modal-warning-scheduling'
      >
        {modal?.body}
      </WarningModal>

    </PageContainer>
  )
}

export default withRootContext(PetAndServices)
